export default "__VITE_PUBLIC_ASSET__d7918682__"